<script setup lang="ts">
  import Carousel from "./Carousel.vue";

  interface CarouselProps {
    icon: string;
    activeIcon?: string;
    title: string;
    desc: string;
    image: string;
  }

  interface SettlementRightProps {
    title: string;
    desc: string;
    imagePlacement: "left" | "right";
    anchorID?: string;
    btnEmit?: (...args: any[]) => void;
    carousel: CarouselProps[];
  }

  defineProps<SettlementRightProps>();
</script>

<template>
  <div class="settlement-right-component">
    <h2 :id="anchorID" class="settlement-right-component-title">{{ title }}</h2>
    <p class="settlement-right-component-desc">{{ desc }}</p>
    <Carousel :carousel="carousel" :image-placement="imagePlacement" :btn-emit="btnEmit" />
  </div>
</template>

<style scoped lang="less">
  .settlement-right-component {
    padding-bottom: 124px;

    .settlement-right-component-title {
      margin-bottom: 14px;
      font-size: 40px;
      font-weight: 600;
      line-height: 47px;
      color: #333;
      text-align: center;

      @media only screen and (max-width: 640px) {
        font-size: 32px;
        line-height: 40px;
      }
    }

    .settlement-right-component-desc {
      margin-bottom: 64px;
      font-size: 24px;
      line-height: 28px;
      color: #5a5d66;
      text-align: center;

      @media only screen and (max-width: 640px) {
        font-size: 18px;
        line-height: 34px;
      }
    }
  }
</style>
